import { useEffect, useState } from 'react';
import { useInterval } from 'usehooks-ts';

import { calcTimeToEndFromNow } from '@/common/lib/date';
import { useAppSelector } from '@/redux/store';

const useCountDownEnergyRefill = (): number | undefined => {
  const timeToNextRefill = useAppSelector(
    (state) => state.user.nextTimeToRefillEnergyForTgem,
  );
  const [secondsToAvailable, setSecondsToAvailable] = useState<
    number | undefined
  >();

  useInterval(
    () => {
      setSecondsToAvailable((state) =>
        state !== undefined ? state - 1 : state,
      );
    },
    secondsToAvailable ? 1000 : null,
  );

  useEffect(() => {
    if (timeToNextRefill) {
      setSecondsToAvailable(
        Math.ceil(calcTimeToEndFromNow(timeToNextRefill) / 1000),
      );
    }
  }, [timeToNextRefill]);

  return secondsToAvailable;
};

export { useCountDownEnergyRefill };
